import React, { Component } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import TransferForm from "./TransferForm";
import ConfirmationStep from "./ConfirmationStep";
import swal from "sweetalert2";
import { APP_CONST, getStoredItem } from "../../store/dataStore";
import { handleError } from "@/util/errorHandler";
import LoadingOverlay from "@/views/Components/LoadingOverlay";

import accountsApi from "@/api/accounts";
import usersApi from "@/api/users";

const initialValues = {
  transferTo: "",
  currency: "KHR",
  amount: "",
  description: "",
  fromName: "",
  fromPhone: "",
  extRef: "",
};

class ManageMainAccount extends Component {
  state = {
    isInitialStep: true,
    values: initialValues,
    isSending: false,
    bankName: "Main Account",
    khrBalance: 0,
    usdBalance: 0,
    xauBalance: 0,
    isAccountDataLoading: true,
  };

  componentDidMount() {
    this.setBankNameFromStorage();
    this.loadBalance();
  }

  setBankNameFromStorage = () => {
    try {
      const userInfo = getStoredItem(APP_CONST.USER_INFO);
      const bankName = JSON.parse(userInfo).participantBankName || "";
      this.setState({ bankName: `${bankName} Main Account` });
    } catch (err) {
      handleError(err);
    }
  };

  loadBalance = async () => {
    try {
      this.setState({ isAccountDataLoading: true });

      const userInfo = JSON.parse(getStoredItem(APP_CONST.USER_INFO));
      const data = await accountsApi.getMainAccountBalance(
        userInfo.participantBankCode,
      );

      this.setState({
        usdBalance: data.assets["usd#nbc"],
        khrBalance: data.assets["khr#nbc"],
        xauBalance: data.assets["xau#nbc"],
      });
    } catch (err) {
      handleError(err);
    } finally {
      this.setState({ isAccountDataLoading: false });
    }
  };

  onSubmit = values => {
    this.setState({ isInitialStep: false, values });
  };

  onBack = () => this.setState({ isInitialStep: true });

  onConfirm = async () => {
    try {
      const { value } = await swal({
        title: "Are you sure?",
        text: 'Please click "Yes" to send',
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      });

      if (!value) return;

      this.setState({ isSending: true });

      const {
        accountId,
        currency,
        amount,
        description,
        accountName,
        fromName,
        fromPhone,
        extRef,
      } = this.state.values;

      const transferObject = {
        destAccountId: accountId,
        assetId: `${currency.toLowerCase()}#nbc`,
        amount,
        srcName: accountName,
        description,
        extRef,
      };

      if (fromName && fromPhone) {
        transferObject.sourceOfFunds = {
          name: fromName,
          phoneNumber: fromPhone,
        };
      }

      await usersApi.transferMoney(transferObject);

      await swal(
        "Money is being transferred",
        "Funds are on the way",
        "success",
      );

      this.setState({ isInitialStep: true, values: initialValues });
    } catch (err) {
      handleError(err);
    } finally {
      this.setState({ isSending: false });
    }
  };

  render() {
    const { isInitialStep, values, isSending, bankName } = this.state;
    const balance = {
      USD: parseFloat(this.state.usdBalance) || 0,
      KHR: parseFloat(this.state.khrBalance) || 0,
      XAU: parseFloat(this.state.xauBalance) || 0,
    };

    return (
      <Card>
        <LoadingOverlay loading={this.state.isAccountDataLoading} />
        <CardHeader data-cy="transfer-from">
          Transfer from: {bankName}
        </CardHeader>
        <CardBody>
          {isInitialStep ? (
            <TransferForm
              onSubmit={this.onSubmit}
              initialValues={values}
              balances={balance}
            />
          ) : (
            <ConfirmationStep
              data={values}
              onBack={this.onBack}
              onConfirm={this.onConfirm}
              isSending={isSending}
              bankName={bankName}
            />
          )}
        </CardBody>
      </Card>
    );
  }
}

export default ManageMainAccount;
